import {
  Button,
  TextField,
  Typography,
  InputAdornment,
  IconButton,
  Link,
  InputLabel,
  Snackbar,
  Alert
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import Grid from "@mui/material/Grid";
import { useState } from "react";
import ForgotPasswordModal from "../components/Modals/ForgetPassowrd";
import { useNavigate } from "react-router-dom";
import DashboardService from "../services/api";

export const Login = () => {
  const navigate = useNavigate();
  const [openSuccessToast, setOpenSuccessToast] = useState(false);
  const [openErrorToast, setOpenErrorToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isForgotPasswordModalOpen, setForgotPasswordModalOpen] =
    useState(false);

  const handleOpenForgotPasswordModal = () => {
    setForgotPasswordModalOpen(true);
  };

  const handleCloseForgotPasswordModal = () => {
    setForgotPasswordModalOpen(false);
  };
  const handleLogin = (event: any) => {
    event.preventDefault();
    DashboardService.login({ email, password })
      .then((res) => {
        if(res.data.success){
          localStorage.setItem("useremail", email);
          localStorage.setItem("userdata", JSON.stringify(res.data));
          localStorage.setItem("accessible_tabs", JSON.stringify(res.data.tabs));
          setToastMessage('Login successful');
          setOpenSuccessToast(true);
          navigate(res.data.tabs.includes("all")?"/":"/yoga-session")
          // navigate("/")
        }
        else{
          setToastMessage(res.data.message);
        setOpenErrorToast(true);
        }
      })
      .catch((error) => {
        console.log(error);
        setToastMessage('Login failed');
        setOpenErrorToast(true);
      });
  };
  const handleSuccessToastClose = (event:any, reason:any) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccessToast(false);
  };

  const handleErrorToastClose = (event:any, reason:any) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenErrorToast(false);
  };

  const handleTogglePassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  return (
    <Grid container>
      <Grid item xs={6} bgcolor={"#e76943"} className="image-container">
        <h1 className="heading">
          Welcome to your Manoshala <br /> Dashboard!
        </h1>
        <span>
          Get all the information you need to promote a mentally <br />
          healthy workplace - right at your fingertips.
        </span>
        <img src="/images/dashboard_new.jpg" alt="Login" className="image" />
      </Grid>
      <Grid
        className="form-container"
        item
        xs={6}
        bgcolor={"white"}
        container
        justifyContent="center"
        alignItems="center"
      >
        <div className="div-form-container">
          <Typography variant="h2" marginBottom={7}>
            Login
          </Typography>
          <form>
            <Grid
              container
              spacing={2}
              justifyContent="center"
              alignItems="center"
            >
              <Grid item xs={12} marginBottom={2}>
                <InputLabel htmlFor="email">Email address</InputLabel>
                <TextField
                  onChange={(e) => setEmail(e.target.value)}
                  fullWidth
                  sx={{ borderRadius: "20px" }}
                />
              </Grid>
              <Grid item xs={12}>
                <InputLabel htmlFor="password">Password</InputLabel>
                <TextField
                  onChange={(e) => setPassword(e.target.value)}
                  fullWidth
                  type={showPassword ? "text" : "password"}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={handleTogglePassword} edge="end">
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid
                item
                xs={12}
                container
                justifyContent="space-between"
                alignItems="center"
                marginBottom={4}
              >
                <Link
                  variant="h5"
                  style={{ cursor: "pointer" }}
                  onClick={handleOpenForgotPasswordModal}
                >
                  Forgot Password?
                </Link>
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  onClick={handleLogin}
                  style={{
                    color: "white",
                    borderRadius: "20px",
                    padding: "10px",
                    width: "30%",
                  }}
                >
                  Login
                </Button>
              </Grid>
            </Grid>
          </form>
        </div>
      </Grid>
      <ForgotPasswordModal
        open={isForgotPasswordModalOpen}
        onClose={handleCloseForgotPasswordModal}
      />
      <Snackbar
        open={openSuccessToast}
        autoHideDuration={6000}
        onClose={handleSuccessToastClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert  severity="success">
          {toastMessage}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openErrorToast}
        autoHideDuration={6000}
        onClose={handleErrorToastClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert  severity="error">
          {toastMessage}
        </Alert>
      </Snackbar>
    </Grid>
  );
};
